export const WEBSHOP_MIN_PRODUCT_QUANTITY = 1;
export const WEBSHOP_PRODUCT_PER_PAGE = 5;
export const WEBSHOP_MIN_STOCK_ORDER_QUANTITY = 0;
export const WEBSHOP_MAX_STOCK_ORDER_QUANTITY = 99;
export const PRODUCT_CATEGORY_DISPOSABLES = 'Disposables';
export const PRODUCT_CATEGORY_LENS_CARE = 'LensCareProducts';
export const STOCK_ORDER_TYPE = 'stock-order';
export const STOCK_ORDER_DISPLAY_TEXT = 'Stock Order Disposables';
export const ORDERHISTORY_MAX_SEARCH_TERM = 30;
const today = new Date();
const twoYearsAgo = new Date();
twoYearsAgo.setFullYear(today.getFullYear() - 2);
export const ORDERHISTORY_SEARCH_MAX_DATE = today.toISOString();
export const ORDERHISTORY_SEARCH_MIN_DATE = twoYearsAgo.toISOString();
